
<script>
	let user = { loggedIn: false };

	function toggle() {
		user.loggedIn = !user.loggedIn;
		window.document.body.classList.toggle('dark-mode');
	}

	const fetchImage = (async () => {
		const response = await fetch('https://api.github.com/search/repositories?q=Yuyu_Scanner')
    return await response.json()
	})()
	
</script>
	

<main data-spy="scroll" data-target="#navbar-nav-header" class="static-layout">
	<meta charset="utf-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="description" content="Core HTML Project">
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

    <!-- External CSS -->

    <!-- Modernizr JS for IE8 support of HTML5 elements and media queries -->
    
	<div class="boxed-page">
		<nav id="gtco-header-navbar" class="navbar navbar-expand-lg py-4">
    <div class="container">
        <a class="navbar-brand d-flex align-items-center">
            {#if user.loggedIn}
			<img src="icons/sun.svg" style="max-width: 40px; width: 100%; cursor: pointer" alt="" on:click={toggle} />
			{/if}

			{#if !user.loggedIn}
			<img src="icons/moon.svg" style="max-width: 40px; width: 100%; cursor: pointer" alt="" on:click={toggle} />
			{/if}
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-nav-header" aria-controls="navbar-nav-header" aria-expanded="false" aria-label="Toggle navigation">
            <span class="lnr lnr-menu"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbar-nav-header">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                    <a class="nav-link" href="#home">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#features">Features</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="https://github.com/justakazh/Yuyu_Scanner">Github</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="mailto:akhmarullah.techno@gmail.com">Contact</a>
                </li>
            </ul>
        </div>
    </div>
</nav>

<div class="jumbotron d-flex align-items-center">
  <div class="container text-center">
    <img src="img/heroku.png" alt="" class="herokuclass" />
    <h1 class="display-2 mb-4 screen-s" style="margin-top: 3%">Yuyu Scanner</h1>
    <p style="max-width: 500px;left: 0;margin: auto;">
      Yuyu Scanner is a Web Reconnaissance & Web Analysis Scanner to find assets and information about targets.
    </p>
    <a  href="https://github.com/justakazh/Yuyu_Scanner" target="_blank" rel="noopener noreferrer">
    <button class="buttonstart"> Get Started</button>
    </a>
<!-- 
	<div class="vl" style="border-left: 5px dotted indianred;height: 150px;width: 0px; left: 0;margin: auto;"></div>
-->
  </div>
</div>		<section id="features" class="bg-white">
    <div class="container">
        <div class="section-content">
            <div class="title-wrap">
                <h2 class="section-title">An automation tool for <br><b>gather information</b></h2>
                <img src="/img/yuyu.gif" alt="" />
                <p style="margin-top: 3%;" class="section-sub-title">The script "yuyu.py" developed in Python is responsible for gather<br/> information from a website by entering URLs.</p>
            </div>
            
            <div class="row text-center">
                <div class="col-md-4 col-sm-6 ">

					{#if user.loggedIn}
						<img src="icons/checklist_white.svg" style="width: 32%;" />
					{/if}
					{#if !user.loggedIn}
						<img src="icons/checklist.svg" style="width: 32%;" />
					{/if}

                    <h5 class="mb-4">Simple</h5>
                    <p>Start information gathering with <br/>just one command even with just <br />a simple command</p>
                </div>
                <!-- /.col-md-4 col-sm-6  -->
                <div class="col-md-4 col-sm-6 ">
					{#if user.loggedIn}
						<img src="icons/terminal_white.svg" style="width: 32%;" />
					{/if}
					{#if !user.loggedIn}
						<img src="icons/terminal.svg" style="width: 32%;" />
					{/if}
                    
                    <h5 class="mb-4">Easy</h5>
                    <p>No need to wait long and search<br /> manually, why not   use the <br />automatic method</p>
                </div>
                <!-- /.col-md-4 col-sm-6  -->
                <div class="col-md-4 col-sm-6 ">
					
					{#if user.loggedIn}
					<img src="icons/open_source_white.svg" style="width: 32%;" />
					{/if}
					{#if !user.loggedIn}
						<img src="icons/open_source.svg" style="width: 32%;" />
					{/if}

                    <h5 class="mb-4">Open Source</h5>
                    <p>Open source and free to use forever. <br />To everyone and let's together<br/> build a better community</p>
                </div>
                <!-- /.col-md-4 col-sm-6  -->
            </div>
            <!-- /.row -->
        </div>
    </div>
</section>		<!-- Counter Section -->
<section id="gtco-counter" class="overlay bg-fixed">
    <div class="container">
        <div class="section-content">
            <div class="row">
                <!-- Counter Item -->
                <div class="col-md-3 col-sm-6 counter-item">
                    
                </div>
                <!-- End of Counter Item -->
                <!-- Counter Item -->
                <div class="col-md-3 col-sm-6 counter-item">
                    <img src="img/stars.svg" style="max-width: 50px;" alt="">

					{#await fetchImage}
						<span class="number" data-from="0" data-to="32" data-refresh-interval="100"></span>
					{:then data}
						<span class="number" data-from="0" data-to="32" data-refresh-interval="100">{data.items[0].stargazers_count}</span>
					{:catch error}
						<span class="number" data-from="0" data-to="32" data-refresh-interval="100">Error</span>
					{/await}

                    <h4>Stars</h4>
                </div>
                <!-- End of Counter Item -->
                <!-- Counter Item -->
                <div class="col-md-3 col-sm-6 counter-item">
                    <img src="img/forks.svg" style="max-width: 50px;" alt="" />
					{#await fetchImage}
						<span class="number" data-from="0" data-to="38" data-refresh-interval="100"></span>
					{:then data}
						<span class="number" data-from="0" data-to="32" data-refresh-interval="100">{data.items[0].forks_count}</span>
					{:catch error}
						<span class="number" data-from="0" data-to="38" data-refresh-interval="100">Error</span>
					{/await}
                    <h4>Forks</h4>
                </div>
                <!-- End of Counter Item -->
                <!-- Counter Item -->
                <div class="col-md-3 col-sm-6 counter-item">
                   
                </div>
                <!-- End of Counter Item -->
            </div>
        </div>
    </div>
</section>
<!-- End of Counter Section -->		<!-- Features Section-->
<section id="gtco-features" class="bg-white">
    <div class="container">
        <div class="section-content">
            <!-- Section Title -->
            <div class="title-wrap">
                <h2 class="section-title">
                    All in one
                </h2>
                <p class="section-sub-title">With just this one tool for many reconnaissance needs, just do it repeatedly <br />and automatically and scalable as needed</p>
            </div>
            <!-- End of Section Title -->
            <div class="row">
                <!-- Features Holder-->
                <div class="col-md-12 features-holder">
                    <div class="row">
                        <!-- Features Item -->
                        <div class="col-md-4 col-sm-6 feature-item item mb-3 mb-3 text-center">
                            <div class="my-4">
								
								{#if user.loggedIn}
									<img src="icons/portscanning_white.svg" style="max-width: 50px;" alt="" />
								{/if}
								{#if !user.loggedIn}
									<img src="icons/portscanning.svg" style="max-width: 50px;" />
								{/if}

                            </div>
                            <h4>Port Scanning</h4>
                            <p>Determining which ports on a network could be receiving data.</p>
                        </div>
                        <!-- End of Feature Item -->
                        <!-- Features Item -->
                        <div class="col-md-4 col-sm-6 feature-item item mb-3 text-center">
                            <div class="my-4">

								{#if user.loggedIn}
									<img src="icons/urldiscovery_white.svg" style="max-width: 50px;" alt="" />
								{/if}
								{#if !user.loggedIn}
									<img src="icons/urldiscovery.svg" style="max-width: 50px;" />
								{/if}

                            </div>
                            <h4>URL Discovery</h4>
                            <p>Fetch all the URLs that the Wayback Machine knows about for a domain</p>
                        </div>
                        <!-- End of Feature Item -->
                        <!-- Features Item -->
                        <div class="col-md-4 col-sm-6 feature-item item mb-3 text-center">
                            <div class="my-4">

								{#if user.loggedIn}
									<img src="icons/ipdiscovery_white.svg" style="max-width: 50px;" alt="" />
								{/if}
								{#if !user.loggedIn}
									<img src="icons/ipdiscovery.svg" style="max-width: 50px;" />
								{/if}

                            </div>
                            <h4>IP Discovery</h4>
                            <p>Scan IP devices through methods like SNMP, ICMP, or neighborhood scanning</p>
                        </div>
                        <!-- End of Feature Item -->
                        <!-- Features Item -->
                        <div class="col-md-4 col-sm-6 feature-item item mb-3 text-center">
                            <div class="my-4">

								{#if user.loggedIn}
									<img src="icons/titlediscovery_white.svg" style="max-width: 50px;" alt="" />
								{/if}
								{#if !user.loggedIn}
									<img src="icons/titlediscovery.svg" style="max-width: 50px;" />
								{/if}

                            </div>
                            <h4>Title Discovery</h4>
                            <p>Title Discovery of target</p>
                        </div>
                        <!-- End of Feature Item -->
                        <!-- Features Item -->
                        <div class="col-md-4 col-sm-6 feature-item item mb-3 text-center">
                            <div class="my-4">

								{#if user.loggedIn}
									<img src="icons/servercheck_white.svg" style="max-width: 50px;" alt="" />
								{/if}
								{#if !user.loggedIn}
									<img src="icons/servercheck.svg" style="max-width: 50px;" />
								{/if}

                            </div>
                            <h4>Web Server Check</h4>
                            <p>hecking availability of hosts, DNS records, IP addresses.</p>
                        </div>
                        <!-- End of Feature Item -->
                        <!-- Features Item -->
                        <div class="col-md-4 col-sm-6 feature-item item mb-3 text-center">
                            <div class="my-4">

								{#if user.loggedIn}
									<img src="icons/filesdiscovery_white.svg" style="max-width: 50px;" alt="" />
								{/if}
								{#if !user.loggedIn}
									<img src="icons/filesdiscovery.svg" style="max-width: 50px;" />
								{/if}

                            </div>
                            <h4>Files Discovery</h4>
                            <p>Common sensitive files Discovery</p>
                        </div>
                        <!-- End of Feature Item -->
                    </div>
                </div>
                <!-- End of Features Holder-->
            </div>
        </div>
    </div>
</section>

<section id="gtco-client" class="bg-white">
    <div class="container">
        <div class="section-content screen-se">
            <!-- Section Title -->
            <div class="title-wrap">
                <h2 class="section-title">
                    <b> Contributors </b>
                </h2>
            </div>
            <!-- End of Section Title -->
            <div class="row ">
                <div class="col-md-2 hide">
                    <!-- Client Item -->
                    <div class="client-item">
                    </div>
                    <!-- End of Client Item  -->
                </div>
                <div class="col-md-2 hide">
                    <!-- Client Item -->
                    <div class="client-item">
                    </div>
                    <!-- End of Client Item -->
                </div>
                <div class="col-md-2">
                    <!-- Client Item  -->
                    <div class="client-item">
						<a href="https://github.com/justakazh/">
                        <img class="img-responsive" src="img/justakazh.webp" alt=" " style="border-radius: 50%;">
						</a>
                    </div>
                    <!-- End of Client Item -->
                </div>
                <div class="col-md-2">
                    <!-- Client Item  -->
                    <div class="client-item">
						<a href="https://github.com/laughface809/">
                        <img class="img-responsive" src="img/laughface809.webp" alt=" " style="border-radius: 50%;">
						</a>
                    </div>
                    <!-- End of Client Item  -->
                </div>
                <div class="col-md-2 hide">
                    <!-- Client Item  -->
                    <div class="client-item">
                    </div>
                    <!-- End of Client Item  -->
                </div>
                <div class="col-md-2">
                    <!-- Client Item  -->
                    <div class="client-item">
                    </div>
                    <!-- End of Client Item -->
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End of Client Section -->		<footer class="mastfoot mb-3 bg-white py-4 border-top">
    <div class="inner container">
         <div class="row">
         	<div class="col-md-6 d-flex align-items-center justify-content-md-start justify-content-center">
         		<p class="mb-0">&copy; 2022 Powered by Svelte & Vercel</p>
         	</div>
            
        </div>
    </div>
</footer>

	<!-- External JS -->
	
</main>

<style>
  :global(body.dark-mode) .jumbotron {
  background-color: #2a2734;
}
:global(body.dark-mode) .bg-white {
  background-color: #2a2734 !important;
}
:global(body.dark-mode) a {
  color: white;
}
:global(body.dark-mode) h1 {
  color: white;
}
:global(body.dark-mode) h2 {
  color: white;
}
:global(body.dark-mode) h4 {
  color: white;
}
:global(body.dark-mode) h5 {
  color: white;
}
:global(body.dark-mode) p {
  color: white;
}
:global(body.dark-mode) .buttonstart {
  color: #2a2734;
  background-color: white;
}
:global(body.dark-mode) #gtco-header-navbar {
  background-color: #2a2734;
}
:global(body.dark-mode) .lnr {
  color: white !important;
}

</style>